import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import '../styles/LegalPages.css';

const PolitiqueConfidentialite = () => {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>{t('privacy.title')}</h1>
        <p className="legal-updated">{t('privacy.lastUpdated')}</p>

        <section className="legal-section">
          <h2>{t('privacy.introTitle')}</h2>
          <p>{t('privacy.introText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.responsibleTitle')}</h2>
          <p><strong>Main2Main</strong></p>
          <p>{t('legal.teamValue')}</p>
          <p>info@main2main.ch</p>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.dataCollectedTitle')}</h2>
          <p>{t('privacy.dataCollectedIntro')}</p>
          <ul>
            <li><strong>{t('privacy.accountData')}:</strong> {t('privacy.accountDataDesc')}</li>
            <li><strong>{t('privacy.transactionData')}:</strong> {t('privacy.transactionDataDesc')}</li>
            <li><strong>{t('privacy.productData')}:</strong> {t('privacy.productDataDesc')}</li>
            <li><strong>{t('privacy.technicalData')}:</strong> {t('privacy.technicalDataDesc')}</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.purposeTitle')}</h2>
          <ul>
            <li>{t('privacy.purpose1')}</li>
            <li>{t('privacy.purpose2')}</li>
            <li>{t('privacy.purpose3')}</li>
            <li>{t('privacy.purpose4')}</li>
            <li>{t('privacy.purpose5')}</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.thirdPartyTitle')}</h2>
          <p>{t('privacy.thirdPartyIntro')}</p>
          <ul>
            <li><strong>Stripe:</strong> {t('privacy.stripeDesc')}</li>
            <li><strong>TWINT:</strong> {t('privacy.twintDesc')}</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.cookiesTitle')}</h2>
          <p>{t('privacy.cookiesText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.retentionTitle')}</h2>
          <p>{t('privacy.retentionText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.rightsTitle')}</h2>
          <p>{t('privacy.rightsIntro')}</p>
          <ul>
            <li>{t('privacy.right1')}</li>
            <li>{t('privacy.right2')}</li>
            <li>{t('privacy.right3')}</li>
            <li>{t('privacy.right4')}</li>
          </ul>
          <p>{t('privacy.rightsContact')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.securityTitle')}</h2>
          <p>{t('privacy.securityText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.changesTitle')}</h2>
          <p>{t('privacy.changesText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('privacy.contactTitle')}</h2>
          <p>{t('privacy.contactText')}</p>
          <p><strong>{t('legal.email')}:</strong> info@main2main.ch</p>
          <p>
            <Link to="/contact" className="legal-link">{t('cgv.contactPage')}</Link>
          </p>
        </section>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;
